module.exports = __webpack_public_path__ + "img/9788963706917.97956697.jpg";